import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Menu, Layout, Avatar, Dropdown } from 'antd';
import AuthActions, { AuthSelectors } from '@redux/AuthRedux';
import './HeaderNav.less';
const { Header } = Layout;

const MENUS = [
  { label: 'Clients', key: 'clients' },
  { label: 'Requests', key: 'requests' },
  { label: 'Properties', key: 'properties' },
  { label: 'Regions', key: 'regions' },
  { label: 'Users', key: 'users' },
  { label: 'Coupons', key: 'coupons' }
];
function MainHeader(props) {
  const {
    location: { pathname },
    logout
  } = props;

  if (pathname === '/pdf') {
    return null;
  }

  const splits = pathname.split('/');
  const selectedKey = splits.length > 1 ? splits[1] : splits[0];
  const [activeMenu, changeActiveMenu] = useState(selectedKey || 'home');

  useEffect(() => {
    const newSplits = pathname.split('/');
    const updatedKey = newSplits.length > 1 ? newSplits[1] : newSplits[0];
    changeActiveMenu(updatedKey);
  }, [pathname]);

  const handleUserMenuClick = () => {
    logout();
  };

  const renderMenus = () => {
    return MENUS.map(({ label, key, ...restProps }) => (
      <Menu.Item key={key} {...restProps}>
        <Link to={`/${key}`}>{label}</Link>
      </Menu.Item>
    ));
  };

  const renderUserMenu = (
    <Menu onClick={handleUserMenuClick}>
      <Menu.Item key="3">Log out</Menu.Item>
    </Menu>
  );

  return (
    <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
      <Menu
        theme="dark"
        style={{ lineHeight: '64px' }}
        onClick={({ key }) => changeActiveMenu(key)}
        selectedKeys={[activeMenu]}
        mode="horizontal"
      >
        {renderMenus()}
        <div
          style={{
            float: 'right',
            display: 'flex',
            cursor: 'pointer',
            justifyContent: 'space-around',
            alignItems: 'center',
            height: '64px'
          }}
        >
          <Dropdown overlay={renderUserMenu}>
            <Avatar style={{ backgroundColor: '#3e90fe' }} icon="user" />
          </Dropdown>
        </div>
      </Menu>
    </Header>
  );
}

MainHeader.propTypes = {
  location: PropTypes.object,
  fullName: PropTypes.string,
  logout: PropTypes.func
};

const mapStateToProps = state => ({
  fullName: AuthSelectors.selectFullName(state)
});

const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(AuthActions.setLoggedOut());
  }
});

const connectedMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainHeader);

export default withRouter(connectedMenu);
